
        var result = require("!!../../node_modules/css-loader/index.js?-url&minimize!../../node_modules/sass-loader/lib/loader.js!./app.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/app.component.scss
// module id = 151
// module chunks = 6